module.exports = __webpack_public_path__ + "2f1c4b6a46ac35368c2c2cd45457c06a.mp3";